module.exports = __webpack_public_path__ + "media/images/emblems/Bavois-coat_of_arms-cffd4b76471bb4c6dca5bef8cded6600.svg";